// extracted by mini-css-extract-plugin
module.exports = {"expenditures":"ConfirmDeliveryToProduction_expenditures__2H0EU","footer":"ConfirmDeliveryToProduction_footer__zFd8v"};